export default [
  {
    path: "home",
    name: "home",
    label: "Conversation",
    icon: "GlobalOutlined",
    url: "/home/index",
  },
  // {
  //   path: "history",
  //   name: "history",
  //   label: "Historical",
  //   icon: "HistoryOutlined",
  //   url: "/history/index",
  // },
  // {
  //   path: "setting",
  //   name: "setting",
  //   label: "Setting",
  //   icon: "SettingOutlined",
  //   url: "/setting/index",
  // },
  {
    path: "pay",
    name: "pay",
    label: "Premium",
    icon: "MoneyCollectOutlined",
    url: "/pay/index",
  },
  {
    path: "user",
    name: "user",
    label: "Account",
    icon: "UserOutlined",
    url: "/user/index",
  },
];
